import { Injectable, inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { DefaultAlertPage } from 'src/app/visual-app/pages/default-alert/default-alert.page';

@Injectable({
    providedIn: "root"
})
export class UtilService {
    private toastController = inject(ToastController);
    private modalController = inject(ModalController);


    async errorToast(errorMessage) {
        // chamadores costumam passar o HttpErrorResponse inteiro; o ion-toast
        // do Ionic 8 não renderiza mensagens que não sejam string
        const message = typeof errorMessage === 'string'
            ? errorMessage
            : (errorMessage?.error?.detail || errorMessage?.message || 'Erro inesperado');
        const toast = await this.toastController.create({
            message,
            duration: 5000,
            color: 'danger'
        });
        toast.present();
    }

    async successToast(msg) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 4000,
            color: 'success'
        });
        toast.present();
    }

    async warning(msg) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 4000,
            color: 'warning'
        });
        toast.present();
    }

    dataURLtoBlob(dataurl: string) {
        const arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            u8arr = new Uint8Array(bstr.length);
        let n = bstr.length;
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    tratarErro(err) {
        const values = Object.values(err.error);
        if (values)
            this.successToast(values[values.length - 1]);
        else
            this.errorToast("Erro inesperado");

    }

    async showConfirmatinAlert(title: string, confirm?: () => void, deny?: () => void) {
        const modal = await this.modalController.create({
            component: DefaultAlertPage,
            cssClass: 'alerta-pagamento',
            componentProps: {
                title: title,
            },
        });
        modal.present();
        modal.onDidDismiss().then((res) => {
            if (res.role === 'confirm') {
                confirm();
            }
            else if (res.role === 'deny') {
                deny();
            }
        });
    }

}